import { useState } from 'react';
import { MONITORING_TYPES } from '../constants';
import chevDownIcon from 'src/assets/images/icons/chevron-down.svg';
import chevDownDisabledIcon from 'src/assets/images/icons/chevron-down-disabled.svg';

interface IProps {
  isContinueMonitoring: Boolean;
  setMonitoringType: any;
  monitoringType: string;
}

const MonitoringTypeDropDown: (props: IProps) => JSX.Element = ({
  isContinueMonitoring,
  setMonitoringType,
  monitoringType,
}) => {
  const [activeId, setActiveId] = useState<Number | null>(null);

  const onSelect = (index: number) => {
    setActiveId(index);
    setMonitoringType(MONITORING_TYPES[index]);
  };

  return (
    <div className="dropdown monitoring-type">
      <button
        className={`form-control ${isContinueMonitoring ? '' : 'disabled'}`}
        type="button"
        id="dropdownMenuButton"
        style={{
          backgroundImage: isContinueMonitoring
            ? `url(${chevDownIcon})`
            : `url(${chevDownDisabledIcon})`,
        }}
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {monitoringType}
      </button>
      <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        {MONITORING_TYPES.map((item: string, idx: number) => (
          <li
            key={idx}
            onClick={() => onSelect(idx)}
            className={`${activeId === idx ? 'active' : ''}`}
          >
            {item}
          </li>
        ))}
      </div>
    </div>
  );
};

export default MonitoringTypeDropDown;
